import * as Constants from '../Constants';
import { isValidEmail } from '../isValidEmail';

function isPresent(s: string) {
  return !!s && s.trim().length > 0;
}

function belowMaxLength(maxLength: number, s: string) {
  return s.length <= maxLength;
}

function containsValidNameCharacters(s: string) {
  const input = s.trim();
  // Check if the entire string is a valid email address - if so, allow it
  if (isValidEmail(input)) {
    return true;
  }

  // names can contain ' and - so we need to make sure we allow them
  const invalidCharactersRegex = /[0-9`!#$%^&*()_+=[\]{};:"\\|,<>/?~]/;

  // Block standalone URLs
  const urlPatternsRegex =
    /^(http[s]?:\/\/|www\.|ftp:\/\/)?[a-zA-Z0-9]+(\.[a-zA-Z]{1,}|(\.[a-zA-Z]{2,}){1,2})(\/\S*)?$/;

  // Block URL protocols anywhere in the string (catches embedded URLs)
  const urlProtocolRegex = /(http[s]?:\/\/|www\.|ftp:\/\/)/i;

  // Block domain-like patterns anywhere (dot followed by 2-6 letters)
  // This catches embedded URLs like "Visit tg6878.com now"
  const domainPatternRegex = /\S+\.[a-z]{2,6}\b/i;

  return (
    !invalidCharactersRegex.test(input) &&
    !urlPatternsRegex.test(input) &&
    !urlProtocolRegex.test(input) &&
    !domainPatternRegex.test(input)
  );
}

export function isValidName(name: string) {
  return (
    isPresent(name) &&
    belowMaxLength(Constants.MAX_STRING_LENGTH_255, name) &&
    containsValidNameCharacters(name)
  );
}
